import src from "IMAGE";
export default { src, width: 1313, height: 2994, blurWidth: 0, blurHeight: 0};
